import * as Sentry from "@sentry/vue";

/**
 * Inicializa o Sentry (erros + performance + Session Replay).
 *
 * Só inicializa quando VUE_APP_SENTRY_DSN está definido, então em dev/local
 * sem DSN nada é enviado.
 *
 * @param {import("vue").App} app Vue 3 application instance.
 * @param {import("vue-router").default} router Instância do vue-router (para
 *   instrumentar transações de navegação/rotas).
 */
export function initSentry(app, router) {
  const dsn = process.env.VUE_APP_SENTRY_DSN;
  if (!dsn) {
    return;
  }

  // Origem da API para propagar os headers de trace (sentry-trace/baggage)
  // apenas nas chamadas ao backend Cake — habilita o trace distribuído.
  let apiTarget;
  try {
    apiTarget = new URL(process.env.VUE_APP_URL_API).origin;
  } catch (e) {
    apiTarget = process.env.VUE_APP_URL_API;
  }

  Sentry.init({
    // Vue 2 passed the constructor; Vue 3 passes the app instance.
    app,
    dsn,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    integrations: [
      // Since @sentry/vue 8 integrations are functions, not classes, and routing
      // instrumentation takes the router directly.
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
      })
    ],
    // Performance: fração de transações com trace.
    tracesSampleRate: parseFloat(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    // Propaga trace só para a API (evita CORS desnecessário com terceiros).
    tracePropagationTargets: [apiTarget],
    // Session Replay: amostra sessões normais e 100% das sessões com erro.
    replaysSessionSampleRate: parseFloat(process.env.VUE_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || "0.1"),
    replaysOnErrorSampleRate: 1.0
  });
}
